export type StoplistAction = 'add' | 'remove'

export const STOPLIST_ACTION_LABELS: Record<StoplistAction, string> = {
  add: 'Add to Stop List',
  remove: 'Remove from Stop List',
}

export const STOPLIST_ACTION_DESCRIPTIONS: Record<StoplistAction, string> = {
  add: 'Add a transaction to the stop list',
  remove: 'Remove a transaction from the stop list',
}
